var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 70.34 58.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#74c26e;}.cls-2{clip-path:url(#clippath-1);}.cls-3{fill:#90d0b9;}.cls-4{clip-path:url(#clippath);}.cls-5{fill:none;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    width: 70.34,
    height: 58.51
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    y: 0,
    width: 70.34,
    height: 58.51
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "capio_icon"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m0,8.72C0,6.55.66,4.69,1.98,3.14,3.73,1.08,6.37,0,9.07,0h52.54c2.39,0,4.44.84,6.15,2.51,1.71,1.67,2.57,3.74,2.57,6.21v41.08c0,2.47-.86,4.54-2.57,6.21-1.71,1.67-3.76,2.51-6.15,2.51H9.07c-2.7,0-5.35-1.08-7.1-3.14C.66,53.82,0,51.96,0,49.8V8.72Zm61.98,41.81V7.98c0-.12-.1-.22-.22-.22H10.46c-1.16,0-2.1.94-2.1,2.1v38.8c0,1.16.94,2.1,2.1,2.1h51.3c.12,0,.22-.1.22-.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m44.06,22.92c0-.76.26-1.4.79-1.91.53-.52,1.16-.77,1.9-.77h16.31c.74,0,1.37.26,1.9.77.53.51.79,1.15.79,1.91v12.66c0,.76-.26,1.4-.79,1.91-.53.52-1.16.77-1.9.77h-16.31c-.74,0-1.37-.26-1.9-.77-.53-.52-.79-1.15-.79-1.91v-12.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m33.78,29.26c0,5.68-4.6,10.28-10.28,10.28s-10.28-4.6-10.28-10.28,4.6-10.28,10.28-10.28,10.28,4.6,10.28,10.28"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.cbfd55aa1fdef27fe92c95e2beef9564.svg";
export { ForwardRef as ReactComponent };